module.exports = __webpack_public_path__ + "media/images/landing/icon-ice-cream-seller-ebf35db359140486629856bf4b5cf749.svg";